import Cookies from "js-cookie";

export function addAddressData(order, ApplicationModel) {
    const one_string_search =
        ApplicationModel?.siteConfig?.settings?.one_string_search?.enabled;

    if (one_string_search) {
        let searchModelOneString = ApplicationModel.searcheModelOneString;
        const currentFullAddress = searchModelOneString.getCurrentFullAddress();

        if (currentFullAddress) {
            order = {
                ...order,
                street: currentFullAddress?.data?.street_full,
                street_id: currentFullAddress?.data?.street_id,
                house: currentFullAddress?.data?.house,
                house_id: currentFullAddress?.data?.address_id,
            };
        }

        if (!order.tariff_id && !!searchModelOneString.actionSelectedTariffId) {
            order.tariff_id = searchModelOneString.actionSelectedTariffId;
        }

        if (!order.region_id) {
            order.region_id = ApplicationModel?.currentRegion?.id;
        }
    } else {
        let searchModel = ApplicationModel.searcheModel;
        let currentStreet = searchModel.getCurrentStreet();
        let currentAddress = searchModel.getCurrentAddress();

        if (currentStreet) {
            order = {
                ...order,
                street: currentStreet?.full_street,
                street_id: currentStreet?.id,
                district_id: currentStreet?.district_id,
                district: currentStreet.district,
            };
        }
        if (currentStreet && currentAddress) {
            order = {
                ...order,
                street: currentStreet?.full_street,
                street_id: currentStreet?.id,
                house: currentAddress?.full,
                house_id: currentAddress?.id,
                address_id: currentAddress?.id,
                district_id: !!currentAddress?.district_id
                    ? currentAddress.district_id
                    : currentStreet?.district_id,
                district: currentStreet.district,
                building: currentAddress?.building,
                construction: currentAddress.construction,
            };
        } else {
            order.house = searchModel?.searcheForm?.fields?.address?.value;
        }

        if (
            !order.tariff_id &&
            !!searchModel.recentlyConnectedSelectedTariffId
        ) {
            order.tariff_id = searchModel.recentlyConnectedSelectedTariffId;
        }
        if (!order.region_id) {
            order.region_id = ApplicationModel?.currentRegion?.id;
        }

        // Какой тариф был выбран с акционного контейнера.
        if (!!searchModel.actionSelectedTariffId) {
            order.tariff_id = searchModel.actionSelectedTariffId;
        }
    }

    return order;
}

export function addABData(order) {
    const experimentMap = window.__EXPERIMENT_MAP__ || [];

    if (experimentMap?.length) {
        const abData = {};

        for (const ex of experimentMap) {
            const ex_name = `AB_${ex?.name}`;

            const variantRaw = Cookies.get(ex_name);

            if (variantRaw) {
                try {
                    const variant = JSON.parse(variantRaw);
                    abData[ex_name] = variant?.name;
                } catch (e) {
                    abData[ex_name] = "Variant parse error";
                }
            } else {
                abData[ex_name] = "Variant has empty value";
            }
        }

        if (Object.keys(abData).length) {
            order["ab"] = abData;
        } else {
            order["ab"] = {
                error: "abData is empty",
            };
        }
    }

    return order;
}
